import React from "react";
import "./loader.css";
import appLogo from "../../Assets/HelpNaoLogo.png";


const Loader = ({ show = true, brand = "HelpNao", message = "Connecting you with trusted service providers...", logoSrc, logoAlt = "Logo", }) => {
  if (!show) return null;

  return (
    <div className="hn-loader-root">
      {/* Main Loader Container */}
      <div className="hn-loader-main">
        {/* Animated Logo/Icon Section */}
        <div className="hn-logo-wrap">
          {/* Outer Rings */}
          <div className="hn-ring hn-ring-1" />
          <div className="hn-ring hn-ring-2" />
          <div className="hn-ring hn-ring-3" />

          {/* Center Icon */}
          <div className="hn-logo-core">
            {/* Handshake Icon (SVG) */}
            {/* <svg className="hn-handshake" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M11.5 2c1.5 0 2.75 1.25 2.75 2.75 0 .5-.25 1-.5 1.25L8.5 11.25c-.25.25-.5.25-.75.25s-.5 0-.75-.25L2.25 6.5c-.25-.25-.25-.75 0-1L6 2.75c.25-.25.75-.25 1 0L8.5 4.25c.25.25.5.25.75.25s.5 0 .75-.25L11.5 2zm6.75 9.5c.5 0 1 .25 1.25.5l4.25 4.25c.25.25.25.75 0 1L19 21.75c-.25.25-.75.25-1 0l-1.5-1.5c-.25-.25-.5-.25-.75-.25s-.5 0-.75.25l-4.75 4.75c-.25.25-.5.25-.75.25s-.5 0-.75-.25c-1.5-1.5-2.75-2.75-2.75-4.25 0-1.5 1.25-2.75 2.75-2.75.5 0 1 .25 1.25.5l1.25 1.25c.25.25.5.25.75.25s.5 0 .75-.25l2.5-2.5c.25-.25.75-.25 1 0z"
              />
            </svg> */}

            <img
              src={logoSrc || appLogo}
              alt="HelpNao"
              className="hn-logo-img"
              decoding="async"
              loading="eager"
              draggable="false"
            />

          </div>
        </div>

        {/* Brand Name */}
        <div className="hn-brand slide-up">
          <h1 className="hn-brand-text">
            {brand.replace(/(.+?)(Nao)/i, (_, a, b) => `${a}||${b}`)}
          </h1>
          {/* Split for colored accent */}
          <span className="hn-brand-mask" aria-hidden="true">
            <span className="hn-brand-main">{brand.split(/Nao/i)[0] || "Help"}</span>
            <span className="hn-brand-accent">Nao</span>
          </span>
        </div>

        {/* Loading Text with Animated Dots */}
        <div className="hn-loading-row slide-up delay-1">
          <span className="hn-loading-label">Loading</span>
          <div className="hn-dots">
            <div className="hn-dot" />
            <div className="hn-dot" />
            <div className="hn-dot" />
          </div>
        </div>

        {/* Circular Loading Spinner */}
        <div className="hn-spinner-wrap slide-up delay-2">
          <div className="hn-spinner" />
        </div>

        {/* Status Text */}
        {/* <p className="hn-status slide-up delay-3">
          {message}
        </p> */}
      </div>

      {/* Background Decorative Elements */}
      <div className="hn-bg">
        <div className="hn-float hn-float-1" />
        <div className="hn-float hn-float-2" />
        <div className="hn-fade hn-fade-1" />
        <div className="hn-fade hn-fade-2" />
      </div>
    </div>
  );
};

export default Loader;
